import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styles from './index.css'

@observer(['cardTableStore'])
export default class Ways extends Component {
  handleClickWay (way, idx) {
    const { cardTableStore, examinationId } = this.props

    if (cardTableStore.wayIdx !== idx) {
      if (way.id === 3) {
        // 练习方式为 套题
        cardTableStore.changeWay(idx, {
          examinationId,
          subjectId: cardTableStore.currentSubject.id
        })
      } else {
        cardTableStore.changeWay(idx, {
          examinationId,
          subjectId: cardTableStore.currentSubject.id,
          questionTypeId: way.id
        })
      }
    }
  }

  render () {
    const { cardTableStore } = this.props

    if (!cardTableStore.ways.length) { return null }

    return (
      <div className={ styles.panel }>
        <div className={ styles.panelTitle }>练习方式</div>
        <div className={ styles.panelList }>
          {
            cardTableStore.ways.map((way, idx) => {
              return (
                <div
                  key={ way.id }
                  className={ cardTableStore.wayIdx === idx ? styles.panelItemActive : styles.panelItem }
                  onClick={ () => this.handleClickWay(way, idx) }>
                    { way.name }
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/Main/Ways.js
 **/